import { useState } from 'react';
import { Button, Field, TextInput } from '../../components/ui';
import { receiverConfig } from './receiverConfig';

export function ReceiverSetup({ airport }: { airport: string }) {
  const [carrier, setCarrier] = useState('');
  let result: ReturnType<typeof receiverConfig> | null = null, error = '';
  if (carrier.trim()) {
    try { result = receiverConfig(airport, carrier); }
    catch (cause) { error = (cause as Error).message; }
  }
  function download() {
    if (!result) return;
    const href = URL.createObjectURL(new Blob([result.config], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = href; link.download = `${airport.toLowerCase()}-rtl_airband.conf`;
    document.body.appendChild(link); link.click(); link.remove();
    // Safari may consume the download after the current event has returned.
    window.setTimeout(() => URL.revokeObjectURL(href), 30_000);
  }
  return <details className="conditions-audio-setup">
    <summary>Set up a receive-only radio</summary>
    <div className="stack-16">
      <p className="muted small">Use an RTL-SDR, an aviation-band antenna and a receiver computer running RTLSDR-Airband 5.x and Icecast. Generate a fixed-channel starter below. Your phone plays the resulting stream; this does not tune hardware or confirm reception.</p>
      <Field label="Receiver carrier frequency (MHz)" hint="Verify the airport’s published assignment. This starter supports 25 kHz carriers only; do not enter an 8.33 kHz channel designator.">{id => <TextInput id={id} inputMode="decimal" value={carrier} maxLength={7} placeholder="123.450" onChange={e => setCarrier(e.target.value)} />}</Field>
      {error && <p className="form-error" role="status">{error}</p>}
      <Button variant="secondary" disabled={!result} onClick={download}>Download receiver configuration</Button>
      {result && <p className="small">Receiver output: <code>{result.mountpoint}</code> · {result.frequency} MHz AM</p>}
      <ol className="small">
        <li>On the receiver computer, protect the downloaded file with <code>chmod 600</code>, replace <code>SET_ON_RECEIVER</code> with your local Icecast source password, and verify device index, gain and frequency correction.</li>
        <li>Start the receiver using <code>rtl_airband -f -c /path/to/config.conf</code>. Check Icecast and listen locally to confirm audible reception. This configuration sends only to Icecast on the same computer and creates no recordings.</li>
        <li>Configure an HTTPS listener endpoint with CORS for Airview Studio’s origin. Keep Icecast administration and source credentials private. Confirm permission to share the received audio with your intended audience.</li>
        <li>In “Connect an audio source,” enter that non-secret HTTPS listener URL and the same frequency, then press Listen. Receiver hardware, hosting and audio access are not provisioned by this download.</li>
      </ol>
      <a href="https://github.com/rtl-airband/RTLSDR-Airband/wiki/Configuration-essentials" target="_blank" rel="noopener noreferrer">RTLSDR-Airband configuration guide</a>
    </div>
  </details>;
}
